// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ItemDetail } from './item-detail';
import { BarcodePrintStatusEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class BarcodePrintStatus extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Enum key */
  id!: BarcodePrintStatusEnum;
  /** String(100) */
  name!: string;
  /** Inv FK barcodePrintStatusId */
  itemDetails!: ItemDetail[];
}

